if (!customElements.get('product-fixed-bar')) {
  customElements.define(
    'product-fixed-bar',
    // eslint-disable-next-line no-undef
    class ProductFixedBar extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.isPermanentlyClosed = false

        this.handleVisibility()
      }

      setupListeners () {
        super.setupListeners()

        if (!this.hasExternalEl('mainProductForm')) return

        this.onScroll = this.onScroll.bind(this)
        this.listeners.add(document, 'DOMContentLoaded', this.onScroll)
        this.listeners.add(window, 'scroll', this.onScroll)

        this.handleScrollBackClick = this.handleScrollBackClick.bind(this)
        this.listeners.add(this, 'click', this.handleScrollBackClick)
        this.listeners.add(
          this.els.editButton.element,
          'click',
          this.displaySelectOptions.bind(this),
        )

        if (this.hasEl('close')) {
          this.handleClose = this.handleClose.bind(this)
          this.listeners.add(this, 'click', this.handleClose)
        }
      }

      onScroll () {
        if (this.isPermanentlyClosed) return

        if (this.hasExternalEl('quickBuyContainer')) {
          this.externalEls.quickBuyContainer.element.setAttribute(
            'aria-hidden',
            'true',
          )
        }
      }

      handleVisibility () {
        const headerEl = this.externalEls.header.element
        const announcementBarEl = this.externalEls.announcementBar.element
        const headerElHeight = headerEl ? headerEl.offsetHeight : 0
        const announcementBarHeight = announcementBarEl
          ? announcementBarEl.offsetHeight
          : 0
        const offsetTop = headerElHeight + announcementBarHeight

        this.createIntersectionObserver = this.createIntersectionObserver.bind(
          this,
        )

        this.createIntersectionObserver(
          this.externalEls.mainProductForm.element,
          offsetTop,
        )

        const footerEl = document.querySelector(
          'footer[data-section-id="footer"]',
        )

        if (footerEl) {
          this.createFooterIntersectionObserver(footerEl)
        }
      }

      handleClose (event) {
        const closeEl = event.target.closest(this.els.close.selector)
        if (!closeEl) return
        this.isPermanentlyClosed = true
        this.setAttribute('aria-hidden', 'true')
      }

      handleScrollBackClick (event) {
        const fixedButtonEl = event.target.closest(
          this.els.fixedButton.selector,
        )
        if (!fixedButtonEl) return

        window.scrollTo({
          top: this.getOffsetTop(this.externalEls.mainProductForm.element) - 90,
          behavior: 'smooth',
        })
      }

      getOffsetTop (el, parent = document.body, offsetTop = 0) {
        if (!el) return offsetTop

        if (!isNaN(el.offsetTop)) {
          offsetTop += el.offsetTop
        }

        return el.offsetParent === parent
          ? offsetTop
          : this.getOffsetTop(el.offsetParent, parent, offsetTop)
      }

      displaySelectOptions () {
        const parentElement = document.querySelector('.prd-FixedBar')
        const stickySelect = document.querySelector('.prd-Options_StickySelect')
        stickySelect.selectedIndex = 0
        parentElement.classList.remove('prd-FixedBar-Selected')
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      hasExternalEl (elementName) {
        return (
          this.externalEls[elementName] && this.externalEls[elementName].exists
        )
      }

      createIntersectionObserver (targetElement, offsetTop = 0) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                document.body.classList.add('product-fixed-bar-active')
                this.setAttribute('aria-hidden', 'false')
              } else {
                document.body.classList.remove('product-fixed-bar-active')
                this.setAttribute('aria-hidden', 'true')
              }
            })
          },
          { threshold: 0, rootMargin: `-${offsetTop}px 0px 0px 0px` },
        )

        observer.observe(targetElement)
      }

      createFooterIntersectionObserver (targetElement){
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                this.classList.remove('prd-FixedBar-FooterOverlap')
              } else {
                this.classList.add('prd-FixedBar-FooterOverlap')
              }
            })
          },
          { threshold: 0, rootMargin: '0px' },
        )

        observer.observe(targetElement)
      }

      set isPermanentlyClosed (boolean) {
        this._isPermanentlyClosed = boolean
      }

      get isPermanentlyClosed () {
        return this._isPermanentlyClosed
      }
    },
  )
}
